import { render, staticRenderFns } from "./Sign-in-up.vue?vue&type=template&id=37b9299c"
import script from "./Sign-in-up.vue?vue&type=script&lang=ts"
export * from "./Sign-in-up.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports